{
  "Your Stripe account, your branding, your price": "Votre compte Stripe, votre personnalisation, votre prix",
  "Our fee is just US $1.50 per ticket sold (introductory offer)": "Nos frais ne sont que de 1,50 $ US par billet vendu (offre de lancement)",
  "All countries and 31 currencies supported": "Tous les pays et 31 devises pris en charge",
  "A fixed price, or let buyers choose the price": "Un prix fixe, ou laissez les acheteurs choisir le prix",
  "Coupons and other Stripe features": "Coupons et autres fonctionnalités de Stripe",
  "Currency": "Devise",
  "Loading currencies…": "Chargement des devises…",
  "Amount": "Montant",
  "Fee": "Frais",
  "{code} - {name} (No auto-conversion)": "{code} - {name} (sans conversion automatique)",
  "Search currency...": "Rechercher une devise...",
  "Add currency": "Ajouter une devise",
  "Single day {price} (24h access)": "Un seul jour {price} (accès 24 h)",
  "All {days} days {price}": "Les {days} jours {price}",
  "Livestream {price} (no replay)": "Direct {price} (sans rediffusion)",
  "Livestream {price}": "Direct {price}",
  "Livestream + Replay {price}": "Direct + rediffusion {price}",
  "+ video download add-on {price}": "+ option téléchargement de la vidéo {price}",
  "+ service & processing fee at checkout": "+ frais de service et de traitement au paiement",
  "Video download {price} (live-only event — no replay)": "Téléchargement de la vidéo {price} (événement uniquement en direct — sans rediffusion)",
  "Nothing (live-only event with downloads off)": "Rien (événement uniquement en direct, téléchargements désactivés)",
  "Replay {price}": "Rediffusion {price}",
  "Replay + download": "Rediffusion + téléchargement",
  "What buyers will see": "Ce que verront les acheteurs",
  "Before & during the event: {items}": "Avant et pendant l’événement : {items}",
  "After the event: {items}": "Après l’événement : {items}",
  "Unlink Stripe Account": "Dissocier le compte Stripe",
  "Are you sure you want to unlink your Stripe account? This will disable ticket sales for this event.": "Voulez-vous vraiment dissocier votre compte Stripe ? La vente de billets sera désactivée pour cet événement.",
  "Failed to unlink Stripe account. Please try again.": "Impossible de dissocier le compte Stripe. Réessayez.",
  "Sell tickets": "Vendre des billets",
  "Couldn't load currencies": "Impossible de charger les devises",
  "Check your connection and try again.": "Vérifiez votre connexion et réessayez.",
  "Guests pay to watch, and the money goes straight to your Stripe account.": "Les invités paient pour regarder, et l’argent va directement sur votre compte Stripe.",
  "Tickets for rooms": "Billets pour les salles",
  "Connect Stripe account": "Connecter un compte Stripe",
  "Copy link to connect Stripe": "Copier le lien de connexion Stripe",
  "Send it to the Stripe account's owner.": "Envoyez-le au titulaire du compte Stripe.",
  "Not your Stripe account? Send the link to its owner so they can connect it.": "Ce n’est pas votre compte Stripe ? Envoyez le lien à son titulaire pour qu’il le connecte.",
  "Stripe fees, refunds and chargebacks are the connected account holder's responsibility. Need help setting up? Ask us in the support chat.": "Les frais Stripe, les remboursements et les rétrofacturations relèvent de la responsabilité du titulaire du compte connecté. Besoin d’aide pour la configuration ? Demandez-nous dans le chat d’assistance.",
  "Stripe account connected": "Compte Stripe connecté",
  "Stripe dashboard": "Tableau de bord Stripe",
  "Refresh": "Actualiser",
  "Unlink": "Dissocier",
  "How guests pay": "Comment les invités paient",
  "Disable Pay-Per-View": "Désactiver le pay-per-view",
  "Use Existing Stripe Price": "Utiliser un prix Stripe existant",
  "Custom Price (Fixed)": "Prix personnalisé (fixe)",
  "Customer Chooses Price": "Le client choisit le prix",
  "Choose how guests pay": "Choisissez comment les invités paient",
  "Select Stripe Price": "Sélectionnez un prix Stripe",
  "price|None": "Aucun",
  "Custom Prices": "Prix personnalisés",
  "This event is live-only, so the ticket includes the livestream only (no replay).": "Cet événement est uniquement en direct : le billet ne comprend que la diffusion en direct (sans rediffusion).",
  "The ticket includes the livestream.": "Le billet comprend la diffusion en direct.",
  "The ticket includes the livestream and the replay.": "Le billet comprend la diffusion en direct et la rediffusion.",
  "Set prices for each currency. First currency becomes the default.": "Définissez un prix pour chaque devise. La première devise devient la devise par défaut.",
  "Sell single-day tickets": "Vendre des billets à la journée",
  "Your price above is the All-Days ticket. Set one price per day below — buyers choose which day. Single-day access lasts 24 hours from that day's scheduled start time.": "Le prix ci-dessus est celui du billet pour tous les jours. Définissez ci-dessous un prix par jour — les acheteurs choisissent leur jour. L’accès d’un jour dure 24 heures à partir de l’heure de début prévue ce jour-là.",
  "Sell video download": "Vendre le téléchargement de la vidéo",
  "Buyers can add the downloadable video to any ticket for this amount.": "Les acheteurs peuvent ajouter la vidéo téléchargeable à n’importe quel billet pour ce montant.",
  "After the event it's sold on its own since this event is live-only.": "Après l’événement, il est vendu séparément, car cet événement est uniquement en direct.",
  "After the event it's sold as Replay + Download.": "Après l’événement, il est vendu sous la forme « Rediffusion + téléchargement ».",
  "Single-day buyers can only download their day.": "Les acheteurs d’un seul jour ne peuvent télécharger que leur jour.",
  "+ Set a different replay price after the event (optional)": "+ Définir un autre prix pour la rediffusion après l’événement (facultatif)",
  "Replay price after the event": "Prix de la rediffusion après l’événement",
  "Use ticket price": "Utiliser le prix du billet",
  "Once the event is over, new buyers pay this instead of the ticket price. You can also change any price at any time.": "Une fois l’événement terminé, les nouveaux acheteurs paient ce prix au lieu du prix du billet. Vous pouvez aussi modifier n’importe quel prix à tout moment.",
  "Add fees at checkout (buyers pay the fees)": "Ajouter les frais au paiement (à la charge des acheteurs)",
  "Buyers pay one combined EventLive + card processing fee on top of your price, so you receive the full amount you set (card fees are estimated at the standard rate — unusual cards may vary slightly).": "Les acheteurs paient, en plus de votre prix, des frais uniques qui combinent ceux d’EventLive et ceux du traitement de la carte : vous recevez ainsi le montant complet que vous avez défini (les frais de carte sont estimés au tarif standard — ils peuvent légèrement varier pour certaines cartes).",
  "Fees are currently deducted from your price: the EventLive fee shown above plus Stripe's card processing fee.": "Les frais sont actuellement déduits de votre prix : les frais EventLive indiqués ci-dessus, plus les frais de traitement de carte de Stripe.",
  "Default Price Suggestions": "Prix suggérés par défaut",
  "These are suggested amounts customers will see, but they can enter any amount they wish.": "Ce sont les montants suggérés que verront les clients, mais ils peuvent saisir le montant de leur choix.",
  "More settings": "Plus de paramètres",
  "Upload logo in Profile Settings": "Importer le logo dans les paramètres du profil",
  "Invite free viewers in Guest List": "Inviter des spectateurs gratuitement depuis la liste d’invités",
  "Customize event branding": "Personnaliser l’événement",
  "Enable payment emails in Stripe": "Activer les e-mails de paiement dans Stripe",
  "Customize branding in Stripe": "Personnaliser l’image de marque dans Stripe",
  "Credits Added Successfully": "Crédits ajoutés",
  "Thank You for Your Purchase!": "Merci pour votre achat !",
  "Your credits are ready to use. You can now:": "Vos crédits sont prêts à être utilisés. Vous pouvez maintenant :",
  "You can now:": "Vous pouvez maintenant :",
  "Use your credits to unlock more events": "Utiliser vos crédits pour débloquer d’autres événements",
  "Check your available balance before your next purchase": "Consulter votre solde disponible avant votre prochain achat",
  "Return to your events and keep editing": "Revenir à vos événements et continuer à les modifier",
  "Invite guests to your event by sharing the event link or using the Guest List feature": "Inviter des personnes à votre événement en partageant le lien de l’événement ou avec la liste d’invités",
  "Open \"How to Go Live\" for a step-by-step guide": "Ouvrir « Comment passer en direct » pour un guide étape par étape",
  "Go live on the day of your event": "Passer en direct le jour de votre événement",
  "Return to Event": "Retour à l’événement",
  "View My Events": "Voir mes événements",
  "Afghanistan": "Afghanistan",
  "Åland Islands": "Îles Åland",
  "Albania": "Albanie",
  "Algeria": "Algérie",
  "American Samoa": "Samoa américaines",
  "Andorra": "Andorre",
  "Angola": "Angola",
  "Anguilla": "Anguilla",
  "Antarctica": "Antarctique",
  "Antigua and Barbuda": "Antigua-et-Barbuda",
  "Argentina": "Argentine",
  "Armenia": "Arménie",
  "Aruba": "Aruba",
  "Australia": "Australie",
  "Austria": "Autriche",
  "Azerbaijan": "Azerbaïdjan",
  "Bahamas": "Bahamas",
  "Bahrain": "Bahreïn",
  "Bangladesh": "Bangladesh",
  "Belgium": "Belgique",
  "Belize": "Belize",
  "Benin": "Bénin",
  "Bermuda": "Bermudes",
  "Bhutan": "Bhoutan",
  "Bolivia": "Bolivie",
  "Bosnia and Herzegovina": "Bosnie-Herzégovine",
  "Botswana": "Botswana",
  "Bouvet Island": "Île Bouvet",
  "Brazil": "Brésil",
  "British Indian Ocean Territory": "Territoire britannique de l’océan Indien",
  "Brunei Darussalam": "Brunei",
  "Bulgaria": "Bulgarie",
  "Burkina Faso": "Burkina Faso",
  "Burundi": "Burundi",
  "Cambodia": "Cambodge",
  "Cameroon": "Cameroun",
  "Canada": "Canada",
  "Cape Verde": "Cap-Vert",
  "Cayman Islands": "Îles Caïmans",
  "Central African Republic": "République centrafricaine",
  "Chad": "Tchad",
  "Chile": "Chili",
  "China": "Chine",
  "Christmas Island": "Île Christmas",
  "Cocos (Keeling) Islands": "Îles Cocos",
  "Colombia": "Colombie",
  "Comoros": "Comores",
  "Congo": "Congo-Brazzaville",
  "Congo, The Democratic Republic of the": "Congo-Kinshasa",
  "Cook Islands": "Îles Cook",
  "Costa Rica": "Costa Rica",
  "Cote D Ivoire": "Côte d’Ivoire",
  "Croatia": "Croatie",
  "Cuba": "Cuba",
  "Cyprus": "Chypre",
  "Czech Republic": "Tchéquie",
  "Denmark": "Danemark",
  "Djibouti": "Djibouti",
  "Dominica": "Dominique",
  "Dominican Republic": "République dominicaine",
  "Ecuador": "Équateur",
  "Egypt": "Égypte",
  "El Salvador": "Salvador",
  "Equatorial Guinea": "Guinée équatoriale",
  "Eritrea": "Érythrée",
  "Estonia": "Estonie",
  "Ethiopia": "Éthiopie",
  "Falkland Islands (Malvinas)": "Îles Malouines",
  "Faroe Islands": "Îles Féroé",
  "Fiji": "Fidji",
  "Finland": "Finlande",
  "France": "France",
  "French Guiana": "Guyane française",
  "French Polynesia": "Polynésie française",
  "French Southern Territories": "Terres australes françaises",
  "Gabon": "Gabon",
  "Gambia": "Gambie",
  "Georgia": "Géorgie",
  "Germany": "Allemagne",
  "Ghana": "Ghana",
  "Gibraltar": "Gibraltar",
  "Greece": "Grèce",
  "Greenland": "Groenland",
  "Grenada": "Grenade",
  "Guadeloupe": "Guadeloupe",
  "Guam": "Guam",
  "Guatemala": "Guatemala",
  "Guernsey": "Guernesey",
  "Guinea": "Guinée",
  "Guinea-Bissau": "Guinée-Bissau",
  "Guyana": "Guyana",
  "Haiti": "Haïti",
  "Heard Island and Mcdonald Islands": "Îles Heard-et-MacDonald",
  "Holy See (Vatican City State)": "État de la Cité du Vatican",
  "Honduras": "Honduras",
  "Hong Kong": "Hong Kong",
  "Hungary": "Hongrie",
  "Iceland": "Islande",
  "India": "Inde",
  "Indonesia": "Indonésie",
  "Iran, Islamic Republic Of": "Iran",
  "Iraq": "Irak",
  "Ireland": "Irlande",
  "Isle of Man": "Île de Man",
  "Israel": "Israël",
  "Italy": "Italie",
  "Jamaica": "Jamaïque",
  "Japan": "Japon",
  "Jersey": "Jersey",
  "Jordan": "Jordanie",
  "Kazakhstan": "Kazakhstan",
  "Kenya": "Kenya",
  "Kiribati": "Kiribati",
  "Korea, Democratic People Republic of": "Corée du Nord",
  "Korea, Republic of": "Corée du Sud",
  "Kuwait": "Koweït",
  "Kyrgyzstan": "Kirghizstan",
  "Lao People Democratic Republic": "Laos",
  "Latvia": "Lettonie",
  "Lebanon": "Liban",
  "Lesotho": "Lesotho",
  "Liberia": "Liberia",
  "Libyan Arab Jamahiriya": "Libye",
  "Liechtenstein": "Liechtenstein",
  "Lithuania": "Lituanie",
  "Luxembourg": "Luxembourg",
  "Macao": "Macao",
  "Macedonia, The Former Yugoslav Republic of": "Macédoine du Nord",
  "Madagascar": "Madagascar",
  "Malawi": "Malawi",
  "Malaysia": "Malaisie",
  "Maldives": "Maldives",
  "Mali": "Mali",
  "Malta": "Malte",
  "Marshall Islands": "Îles Marshall",
  "Martinique": "Martinique",
  "Mauritania": "Mauritanie",
  "Mauritius": "Maurice",
  "Mayotte": "Mayotte",
  "Mexico": "Mexique",
  "Micronesia, Federated States of": "Micronésie",
  "Moldova, Republic of": "Moldavie",
  "Monaco": "Monaco",
  "Mongolia": "Mongolie",
  "Montserrat": "Montserrat",
  "Morocco": "Maroc",
  "Mozambique": "Mozambique",
  "Myanmar": "Myanmar (Birmanie)",
  "Namibia": "Namibie",
  "Nauru": "Nauru",
  "Nepal": "Népal",
  "Netherlands": "Pays-Bas",
  "Netherlands Antilles": "Antilles néerlandaises",
  "New Caledonia": "Nouvelle-Calédonie",
  "New Zealand": "Nouvelle-Zélande",
  "Nicaragua": "Nicaragua",
  "Niger": "Niger",
  "Nigeria": "Nigeria",
  "Niue": "Niue",
  "Norfolk Island": "Île Norfolk",
  "Northern Mariana Islands": "Îles Mariannes du Nord",
  "Norway": "Norvège",
  "Oman": "Oman",
  "Pakistan": "Pakistan",
  "Palau": "Palaos",
  "Palestinian Territory, Occupied": "Palestine",
  "Panama": "Panama",
  "Papua New Guinea": "Papouasie-Nouvelle-Guinée",
  "Paraguay": "Paraguay",
  "Peru": "Pérou",
  "Philippines": "Philippines",
  "Pitcairn": "Îles Pitcairn",
  "Poland": "Pologne",
  "Portugal": "Portugal",
  "Puerto Rico": "Porto Rico",
  "Qatar": "Qatar",
  "Reunion": "La Réunion",
  "Romania": "Roumanie",
  "Russian Federation": "Russie",
  "RWANDA": "Rwanda",
  "Saint Helena": "Sainte-Hélène",
  "Saint Kitts and Nevis": "Saint-Christophe-et-Niévès",
  "Saint Lucia": "Sainte-Lucie",
  "Saint Pierre and Miquelon": "Saint-Pierre-et-Miquelon",
  "Saint Vincent and the Grenadines": "Saint-Vincent-et-les Grenadines",
  "Samoa": "Samoa",
  "San Marino": "Saint-Marin",
  "Sao Tome and Principe": "Sao Tomé-et-Principe",
  "Saudi Arabia": "Arabie saoudite",
  "Senegal": "Sénégal",
  "Serbia and Montenegro": "Serbie-et-Monténégro",
  "Seychelles": "Seychelles",
  "Sierra Leone": "Sierra Leone",
  "Singapore": "Singapour",
  "Slovakia": "Slovaquie",
  "Slovenia": "Slovénie",
  "Solomon Islands": "Îles Salomon",
  "Somalia": "Somalie",
  "South Africa": "Afrique du Sud",
  "South Georgia and the South Sandwich Islands": "Géorgie du Sud-et-les Îles Sandwich du Sud",
  "Spain": "Espagne",
  "Sri Lanka": "Sri Lanka",
  "Sudan": "Soudan",
  "Suriname": "Suriname",
  "Svalbard and Jan Mayen": "Svalbard et Jan Mayen",
  "Swaziland": "Eswatini",
  "Sweden": "Suède",
  "Switzerland": "Suisse",
  "Syrian Arab Republic": "Syrie",
  "Taiwan, Province of China": "Taïwan",
  "Tajikistan": "Tadjikistan",
  "Tanzania, United Republic of": "Tanzanie",
  "Thailand": "Thaïlande",
  "Timor-Leste": "Timor oriental",
  "Togo": "Togo",
  "Tokelau": "Tokelau",
  "Tonga": "Tonga",
  "Trinidad and Tobago": "Trinité-et-Tobago",
  "Tunisia": "Tunisie",
  "Turkey": "Turquie",
  "Turkmenistan": "Turkménistan",
  "Turks and Caicos Islands": "Îles Turques-et-Caïques",
  "Tuvalu": "Tuvalu",
  "Uganda": "Ouganda",
  "Ukraine": "Ukraine",
  "United Arab Emirates": "Émirats arabes unis",
  "United Kingdom": "Royaume-Uni",
  "United States": "États-Unis",
  "United States Minor Outlying Islands": "Îles mineures éloignées des États-Unis",
  "Uruguay": "Uruguay",
  "Uzbekistan": "Ouzbékistan",
  "Vanuatu": "Vanuatu",
  "Venezuela": "Venezuela",
  "Viet Nam": "Viêt Nam",
  "Virgin Islands, British": "Îles Vierges britanniques",
  "Virgin Islands, U.S.": "Îles Vierges des États-Unis",
  "Wallis and Futuna": "Wallis-et-Futuna",
  "Western Sahara": "Sahara occidental",
  "Yemen": "Yémen",
  "Zambia": "Zambie",
  "Zimbabwe": "Zimbabwe",
  "Your client's account · used for {count} event": {
    "one": "Compte de votre client · utilisé pour {count} événement",
    "other": "Compte de votre client · utilisé pour {count} événements"
  },
  "Your client's account": "Compte de votre client",
  "Your account · used for {count} event": {
    "one": "Votre compte · utilisé pour {count} événement",
    "other": "Votre compte · utilisé pour {count} événements"
  },
  "Your account": "Votre compte",
  "Used for {count} event": {
    "one": "Utilisé pour {count} événement",
    "other": "Utilisé pour {count} événements"
  },
  "Connected before": "Déjà connecté",
  "Ticket payouts for “{event}” will go to {account}, your client's Stripe account. Use it only for this client's events.": "Les virements de la billetterie de « {event} » iront sur {account}, le compte Stripe de votre client. Utilisez-le uniquement pour les événements de ce client.",
  "Ticket payouts for “{event}” will go to {account}.": "Les virements de la billetterie de « {event} » iront sur {account}.",
  "Use this account": "Utiliser ce compte",
  "Couldn't use this Stripe account": "Impossible d’utiliser ce compte Stripe",
  "Use a Stripe account you've connected before": "Utilisez un compte Stripe déjà connecté",
  "Or connect another Stripe account:": "Ou connectez un autre compte Stripe :",
  "Connect another Stripe account": "Connecter un autre compte Stripe"
}
